// extracted by mini-css-extract-plugin
module.exports = {"logoWrapper":"AppLogo_logoWrapper__2TqNV","logo":"AppLogo_logo__3Emxo","subtitle":"AppLogo_subtitle__2bIAU"};